import React from 'react';

interface MobileMenuButtonProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
  isDashboardPage: boolean;
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({
  mobileMenuOpen,
  setMobileMenuOpen,
  isDashboardPage,
}) => {
  return (
    <button
      onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      className={`p-2 rounded-xl transition-all duration-200 ${
        isDashboardPage
          ? 'lg:text-gray-700 lg:hover:bg-gray-100 lg:border lg:border-transparent lg:hover:border-gray-200 text-gray-600 hover:text-gray-900 hover:bg-gray-100'
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
      }`}
      aria-label="Mobile menu"
    >
      {/* Custom hamburger icon with 3 lines getting shorter from top to bottom */}
      <div className="flex flex-col gap-1 items-end">
        <div className="w-6 h-0.5 bg-current"></div>
        <div className="w-5 h-0.5 bg-current"></div>
        <div className="w-4 h-0.5 bg-current"></div>
      </div>
    </button>
  );
}; 